<template>
     <div
        class="js-post"
        :class="{ 'fl-post-feed-post':feedLayout, 'fl-post-column':columnLayout }">

            <div :class="{ 'fl-post-feed-post':feedLayout, 'fl-post-column-post':columnLayout }">

                <FeaturedImage
                    v-if="parseInt(moduleSettings.show_image) == 1 && postObj.images.has_image == true"
                    :postObj="postObj"
                    :hrefTarget="hrefTarget"
                    :moduleSettings="moduleSettings"
                    :postLabel="postLabel"
                    :postTerm="postTerm"
                    />

                <div class="fl-post-grid-text">

                    <PostTitle :postObj="postObj" :hrefTarget="hrefTarget" />

                    <PostMeta :postObj="postObj" :moduleSettings="moduleSettings" :postLabel="postLabel" :postTerm="postTerm" />

                    <PostContent :postObj="postObj" :hrefTarget="hrefTarget" :moduleSettings="moduleSettings" />

                </div>
            </div>
        </div>
</template>

<script>

import FeaturedImage from './FeaturedImage.vue'
import PostTitle from './PostTitle.vue'
import PostMeta from './PostMeta.vue'
import PostContent from './PostContent.vue'

export default {
  props: {
    postObj: {
      type: Object
    },
    moduleSettings: {
      type: Object
    },
    columnLayout: {
      type: Boolean
    },
    feedLayout: {
      type: Boolean
    }
  },
  components: {
    FeaturedImage,
    PostTitle,
    PostMeta,
    PostContent
  },
  computed: {
    hrefTarget: function () {
      const targetUrl = new URL(this.postObj.link)
      return targetUrl.host !== window.location.host ? '_blank' : '_self'
    },
    postLabel: function () {
      const post = this.postObj
      const sourceIndex = parseInt(post.source)
      const sourceSettings = this.moduleSettings.sources[sourceIndex]
      return sourceSettings.label
    },
    postTerm: function () {
      let result = ''
      const post = this.postObj
      const targetUrl = new URL(this.postObj.link)
      if (targetUrl.host !== window.location.host) {
        return ''
      }
      const sourceIndex = parseInt(post.source)
      const sourceSettings = this.moduleSettings.sources[sourceIndex]

      const taxonomyFilters = ['aihe', 'uutisen-avainsana', 'category', 'tag']

      // Return tax term name matching user selected filters
      for (let taxIndex in taxonomyFilters) {
        const taxonomy = taxonomyFilters[taxIndex]
        let selectedTaxTerms = null
        let postTaxTerms = {}

        // Get taxonomy term filters from source settings, if any
        if (typeof sourceSettings[taxonomy] !== 'undefined' && sourceSettings[taxonomy].length > 0) {
          selectedTaxTerms = sourceSettings[taxonomy].split(',')
        }
        // Get current post's terms in selected taxonomy, if has terms in selected taxonomy
        if (typeof post.terms[taxonomy] !== 'undefined') {
          post.terms[taxonomy].map((term) => {
            postTaxTerms = Object.assign({}, postTaxTerms, { [term.term_id]: term.term_name })
          })
        }

        // Proceed if there are term filters and post has terms in current taxonomy
        if (selectedTaxTerms && Object.keys(postTaxTerms).length > 0) {
          for (let termIndex in selectedTaxTerms) {
            const selectedTermId = parseInt(selectedTaxTerms[termIndex])
            // Get the first matching taxonomy term
            if (typeof postTaxTerms[selectedTermId] !== 'undefined' && result.length === 0) {
              result = postTaxTerms[selectedTermId]
            }
          }
        }
      }

      // If there are no taxonomy filters selected and no matching tax terms found in posts, try getting first term in any taxonomy
      if (result.length === 0) {
        for (let taxIndex in taxonomyFilters) {
          const taxonomy = taxonomyFilters[taxIndex]
          if (typeof post.terms[taxonomy] !== 'undefined' && post.terms[taxonomy].length > 0 && result.length === 0) {
            result = post.terms[taxonomy][0].term_name
          }
        }
      }

      return result
    }
  }
}
</script>
